import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "p-input-icon-left" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "p-d-flex p-justify-end" }

import { ref, watch } from "vue";
import CategoryMultiSelect from "@/components/category/CategoryMultiSelect.vue";
import {
  StockRowQuantity,
  useUpdateQuantities,
} from "@/graphql/stock/update.quantities";
import { activeActivity } from "@/plugins/i18n";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import { Category, Product } from "@/graphql/types";
import { useStockPermissions } from "@/hooks/permissions/useStockPermission";
import { getImage } from "@/graphql/utils/utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'Inventory',
  props: {
    products: { default: () => [] },
    categories: { default: () => [] },
    loading: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;
const defaultFilters = {
  global: { value: "", matchMode: FilterMatchMode.CONTAINS },
  "product.reference": {
    operator: FilterOperator.AND,
    constraints: [{ value: "", matchMode: FilterMatchMode.STARTS_WITH }],
  },
  "product.name": {
    operator: FilterOperator.AND,
    constraints: [{ value: "", matchMode: FilterMatchMode.STARTS_WITH }],
  },
  "product.category.id": {
    operator: FilterOperator.AND,
    constraints: [{ value: [], matchMode: FilterMatchMode.IN }],
  },
  quantity: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
  },
};
const currency = activeActivity.value.currencySymbol;
const stocks = ref<StockRowQuantity[]>([]);
const filters = ref({ ...defaultFilters });
const { updateQuantities2, qLoading } = useUpdateQuantities(() => ({}));
const { canUpdate } = useStockPermissions();

function tabIndexSkipper() {
  setTimeout(() => {
    document.querySelectorAll(".p-button").forEach((button: any) => {
      button.tabIndex = -1;
    });
  }, 100);
}

watch(
  () => props.products,
  (prod) => {
    stocks.value = prod.reduce((acc, prod) => {
      if (prod.type === 0) {
        const { stocks, ...product } = prod;
        return acc.concat(
          stocks.map((st) =>
            Object.assign({ ...st }, { product, nq: st.quantity })
          )
        );
      }
      return acc;
    }, []);
    tabIndexSkipper();
  },
  { immediate: true }
);

function updateQuantities() {
  updateQuantities2(stocks.value);
}

function clearFilter() {
  Object.assign(filters.value, defaultFilters);
  filters.value.global.value = "";
}

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Image = _resolveComponent("Image")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_NumberFormatter = _resolveComponent("NumberFormatter")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createBlock(_component_DataTable, {
    class: "p-datatable-sm",
    "data-key": "id",
    value: stocks.value,
    responsiveLayout: "scroll",
    loading: _ctx.loading,
    filters: filters.value,
    "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => ((filters).value = $event)),
    filterDisplay: "menu",
    "show-gridlines": "",
    globalFilterFields: [
      'product.reference',
      'product.name',
      'product.category.label',
    ]
  }, _createSlots({
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, null, {
        start: _withCtx(() => [
          _createVNode(_component_Button, {
            type: "button",
            icon: "pi pi-filter-slash",
            label: _ctx.$t('clear'),
            class: "p-button-outlined p-mb-1",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (clearFilter()))
          }, null, 8, ["label"])
        ]),
        end: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, [
            _hoisted_2,
            _createVNode(_component_InputText, {
              modelValue: filters.value['global'].value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.value['global'].value) = $event)),
              placeholder: _ctx.$t('search'),
              "icon-pos": "right"
            }, null, 8, ["modelValue", "placeholder"])
          ])
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Column, {
        style: {"min-width":"3rem"},
        header: _ctx.$t('image')
      }, {
        body: _withCtx(({ data }) => [
          (data.product.image)
            ? (_openBlock(), _createBlock(_component_Image, {
                key: 0,
                src: _unref(getImage)(data.product.image),
                height: 50,
                preview: ""
              }, null, 8, ["src"]))
            : (_openBlock(), _createBlock(_component_Avatar, {
                key: 1,
                label: data.product.name[0],
                size: "large"
              }, null, 8, ["label"]))
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, {
        "show-add-button": false,
        showFilterOperator: false,
        header: _ctx.$t('product.reference'),
        filterField: "product.reference",
        field: "product.reference",
        sortable: true,
        "sort-field": "product.reference"
      }, {
        filter: _withCtx(({ filterModel, filterCallback }) => [
          _createVNode(_component_InputText, {
            type: "text",
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            onKeyup: _withKeys(filterCallback, ["enter"]),
            class: "p-column-filter",
            placeholder: _ctx.$t('product.filterByRef')
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup", "placeholder"])
        ]),
        filterclear: _withCtx(({ filterCallback }) => [
          _createVNode(_component_Button, {
            type: "button",
            icon: "pi pi-times",
            onClick: ($event: any) => (filterCallback()),
            class: "p-button-warning p-mr-1",
            label: _ctx.$t('prime.clear')
          }, null, 8, ["onClick", "label"])
        ]),
        filterapply: _withCtx(({ filterCallback }) => [
          _createVNode(_component_Button, {
            onClick: filterCallback,
            type: "button",
            icon: "pi pi-search",
            class: "p-button-success",
            label: _ctx.$t('search')
          }, null, 8, ["onClick", "label"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, {
        "show-add-button": false,
        showFilterOperator: false,
        header: _ctx.$t('stock.product'),
        filterField: "product.name",
        field: "product.id",
        sortable: true,
        "sort-field": "product.name"
      }, {
        body: _withCtx(({ data }) => [
          _createTextVNode(_toDisplayString(data.product.name), 1)
        ]),
        filter: _withCtx(({ filterModel, filterCallback }) => [
          _createVNode(_component_InputText, {
            type: "text",
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            class: "p-column-filter",
            onKeyup: _withKeys(filterCallback, ["enter"]),
            placeholder: _ctx.$t('product.filterByName')
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup", "placeholder"])
        ]),
        filterclear: _withCtx(({ filterCallback }) => [
          _createVNode(_component_Button, {
            type: "button",
            icon: "pi pi-times",
            onClick: ($event: any) => (filterCallback()),
            class: "p-button-warning p-mr-1",
            label: _ctx.$t('prime.clear')
          }, null, 8, ["onClick", "label"])
        ]),
        filterapply: _withCtx(({ filterCallback }) => [
          _createVNode(_component_Button, {
            onClick: filterCallback,
            type: "button",
            icon: "pi pi-search",
            class: "p-button-success",
            label: _ctx.$t('search')
          }, null, 8, ["onClick", "label"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, {
        showFilterMatchModes: false,
        "show-add-button": false,
        showFilterOperator: false,
        field: "product.category.id",
        sortable: true,
        "filter-field": "product.category.id",
        header: _ctx.$t('product.category'),
        "show-apply-button": false
      }, {
        body: _withCtx(({ data }) => [
          _createTextVNode(_toDisplayString(data.product.category.label), 1)
        ]),
        filter: _withCtx(({ filterModel, filterCallback }) => [
          _createVNode(CategoryMultiSelect, {
            modelValue: filterModel.value,
            "onUpdate:modelValue": [($event: any) => ((filterModel.value) = $event), ($event: any) => (filterCallback())],
            items: _ctx.categories,
            style: {"max-width":"220px"}
          }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
        ]),
        filterclear: _withCtx(({ filterCallback }) => [
          _createVNode(_component_Button, {
            type: "button",
            icon: "pi pi-times",
            onClick: ($event: any) => (filterCallback()),
            label: _ctx.$t('clear'),
            style: {"width":"100%"}
          }, null, 8, ["onClick", "label"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, {
        "sort-field": "quantity",
        sortable: true,
        field: "quantity",
        header: _ctx.$t('stock.quantity'),
        style: {"max-width":"160px","overflow":"auto"},
        "show-add-button": false,
        showFilterOperator: false,
        "filter-field": "quantity",
        dataType: "numeric"
      }, {
        body: _withCtx(({ data }) => [
          _createVNode(_component_InputNumber, {
            style: {"height":"30px"},
            disabled: !_unref(canUpdate),
            showButtons: "",
            buttonLayout: "horizontal",
            decrementButtonClass: "p-button-danger addon",
            incrementButtonClass: "p-button-success addon",
            incrementButtonIcon: "pi pi-plus",
            decrementButtonIcon: "pi pi-minus",
            mode: "decimal",
            "input-style": "max-width: 95px",
            "max-fraction-digits": 20,
            modelValue: data.nq,
            "onUpdate:modelValue": ($event: any) => ((data.nq) = $event)
          }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
        ]),
        filter: _withCtx(({ filterModel }) => [
          _createVNode(_component_InputNumber, {
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            "max-fraction-digits": 20,
            min: 0,
            mode: "decimal"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        filterclear: _withCtx(({ filterCallback }) => [
          _createVNode(_component_Button, {
            type: "button",
            onClick: ($event: any) => (filterCallback()),
            class: "p-button-warning p-button-sm",
            label: _ctx.$t('prime.clear')
          }, null, 8, ["onClick", "label"])
        ]),
        filterapply: _withCtx(({ filterCallback }) => [
          _createVNode(_component_Button, {
            label: _ctx.$t('search'),
            type: "button",
            icon: "pi pi-search",
            class: "p-button-sm",
            onClick: ($event: any) => (filterCallback())
          }, null, 8, ["label", "onClick"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, {
        header: _ctx.$t('stock.detail')
      }, {
        body: _withCtx(({ data }) => [
          _createTextVNode(_toDisplayString(_ctx.$t("stock.purchasePrice")) + " : ", 1),
          _createVNode(_component_NumberFormatter, {
            value: data.purchasePrice
          }, null, 8, ["value"]),
          _createTextVNode(" " + _toDisplayString(_unref(currency)) + " ", 1),
          _hoisted_3,
          _createTextVNode(" " + _toDisplayString(_ctx.$t("stock.sellingPrice")) + " : ", 1),
          _createVNode(_component_NumberFormatter, {
            value: data.inclTax
          }, null, 8, ["value"]),
          _createTextVNode(" " + _toDisplayString(_unref(currency)) + " ", 1),
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(data.expiredAt && _ctx.$t("stock.exp") + _ctx.$d(data.expiredAt)), 1)
        ]),
        _: 1
      }, 8, ["header"])
    ]),
    _: 2
  }, [
    (_unref(canUpdate))
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Button, {
                onClick: updateQuantities,
                loading: _unref(qLoading),
                disabled: _unref(qLoading),
                label: _ctx.$t('terminal.saveChanges'),
                icon: "pi pi-save"
              }, null, 8, ["loading", "disabled", "label"])
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["value", "loading", "filters"]))
}
}

})